import React, { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from './config';
import { store, createClientStore } from './store';

import './styles/global.scss';
import RoutesByType from './routing/RoutesByType';
import { AuthProvider } from './context/AuthProvider';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    environment: 'production',
  });
}

const isLocalBuild = process.env.CI_ENV === 'local';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ssrState = (globalThis as any).__REDUX_STATE__;
const activeStore = ssrState ? createClientStore(ssrState) : store;

const rootContainer = document.getElementById('root');

if (rootContainer) {
  const app = (
    <AuthProvider>
      <Provider store={activeStore}>
        {isLocalBuild ? (
          <StrictMode>
            <RoutesByType />
          </StrictMode>
        ) : (
          <RoutesByType />
        )}
      </Provider>
    </AuthProvider>
  );

  if (ssrState) {
    hydrateRoot(rootContainer, app);
  } else {
    createRoot(rootContainer).render(app);
  }
}
